import { createFileRoute } from '@tanstack/react-router'
import { LibraPage } from 'pages/libra/LibraPage'

export const Route = createFileRoute('/libra/$orgID/$workflowId')({
  component: RouteComponent,
  staticData: {
    title: 'Libra',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  return <LibraPage />
}
